<template>
  <component :is="betaComponent" v-if="variant === 'beta'" v-bind="betaProps" />
  <component :is="classicComponent" v-else-if="variant === 'classic'" />
  <div v-else style="min-height:60vh;"></div>
</template>

<script>
// Route-level gate for every Beta selector surface. Same URLs as always; the
// per-product PostHog flag decides which UI renders. Hard default is classic —
// flag off, SDK blocked, or flags not loaded in time all land there.
//
// product prop values: 'IFP' | 'IMP' | 'COMPANY_PROFILE' | 'PROSPECT_LIST'
//                    | 'VALUATION_REPORT' | 'COMPANY_REPORT'
// The IFP/IMP routes double as Financial/Market Report when the NewReport
// picker sends a ?data-id= query — the gate upgrades the product accordingly
// (separate flags, separate classic behavior, same URL).
import SelectorPage from './SelectorPage.vue';
import CompanyPage from './CompanyPage.vue';
import ProspectPage from './ProspectPage.vue';
import ReportPage from './ReportPage.vue';
import { resolveSelectorVariant } from './flag';

export default {
  name: 'selector-gate',
  props: {
    product: { type: String, required: true },
  },
  data() {
    return { variant: null };
  },
  computed: {
    hasDataId() {
      return !!this.$route.query['data-id'];
    },
    productKey() {
      switch (this.product) {
        case 'IFP': return this.hasDataId ? 'financial_report' : 'ifp';
        case 'IMP': return this.hasDataId ? 'market_report' : 'imp';
        case 'COMPANY_PROFILE': return 'company_profile';
        case 'PROSPECT_LIST': return 'prospect_list';
        case 'VALUATION_REPORT': return 'valuation_report';
        case 'COMPANY_REPORT': return 'company_report';
        default: return 'ifp';
      }
    },
    betaComponent() {
      switch (this.productKey) {
        case 'ifp':
        case 'imp': return SelectorPage;
        case 'company_profile': return CompanyPage;
        case 'prospect_list': return ProspectPage;
        default: return ReportPage;
      }
    },
    betaProps() {
      switch (this.productKey) {
        case 'ifp': return { product: 'IFP' };
        case 'imp': return { product: 'IMP' };
        case 'financial_report': return { kind: 'financial' };
        case 'market_report': return { kind: 'market' };
        case 'valuation_report': return { kind: 'valuation' };
        case 'company_report': return { kind: 'company' };
        default: return {};
      }
    },
    classicComponent() {
      // lazy so the classic bundles aren't parsed when the Beta renders
      switch (this.product) {
        case 'IMP': return () => import('@/pages/Bizminer/Profiles/NewMarketProfile.vue');
        case 'COMPANY_PROFILE': return () => import('@/pages/Bizminer/Search/CompanySearch.vue');
        case 'PROSPECT_LIST': return () => import('@/pages/Bizminer/Search/ProspectSearch.vue');
        case 'VALUATION_REPORT': return () => import('@/pages/Bizminer/Profiles/NewValuationReport.vue');
        case 'COMPANY_REPORT': return () => import('@/pages/Bizminer/Profiles/NewCompanyReport.vue');
        default: return () => import('@/pages/Bizminer/Profiles/NewProfile.vue');
      }
    },
  },
  async created() {
    this.variant = await resolveSelectorVariant(this.productKey);
  },
};
</script>
